import { createStore } from 'vuex'

// Конфигурация API
const YOUTUBE_API = {
  KEY: process.env.VUE_APP_YOUTUBE_API_KEY || 'AIzaSyDXBzoa8SXA5L_zJUpk8IG_58BUCvvZios',
  CHANNEL_ID: 'UCSb71yKJmS0eHyhRRl00ioQ',
  UPLOADS_PLAYLIST_ID: 'UUSb71yKJmS0eHyhRRl00ioQ',
  ENDPOINTS: {
    playlist: (playlistId, maxResults, key) =>
      `https://www.googleapis.com/youtube/v3/playlistItems?playlistId=${playlistId}&part=snippet&maxResults=${maxResults}&key=${key}`,
    live: (channelId, key) =>
      `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&eventType=live&type=video&key=${key}`
  }
}

// Ограничение запросов
const RATE_LIMIT = {
  REQUESTS_PER_MINUTE: 5,
  RESET_TIME: 60000 // 1 минута в миллисекундах
}

export default createStore({
  state: {
    icons: [
      {
        fontawesome: 'fab fa-facebook-f fa-2x',
        icon: 'mdi-facebook',
        name: 'facebook',
        src: 'https://www.facebook.com/Церковь-Благая-Весть-Черкассы-746415165547326/'
      },
      {
        fontawesome: 'fab fa-youtube fa-2x',
        icon: 'mdi-youtube-tv',
        name: 'youtube',
        src: 'https://www.youtube.com/channel/UCSb71yKJmS0eHyhRRl00ioQ'
      },
      {
        fontawesome: 'fa fa-envelope fa-2x',
        icon: 'mdi-email',
        name: 'email',
        src: 'mailto:info@bv.ck.ua'
      },
      {
        fontawesome: 'fab fa-instagram fa-2x',
        icon: 'mdi-instagram',
        name: 'instagram',
        src: 'https://www.instagram.com/bv.ck.ua/'
      }
    ],
    icon: [],
    youtubeData: {
      lastVideo: null,
      liveVideo: null,
      videoList: []
    },
    videosPerPage: 10,
    user: {
      isLoggedIn: false,
      isAdmin: false,
      id: null
    },
    rateLimit: {
      count: 0,
      isLimited: false
    },

    // Старые поля для обратной совместимости
    LastVideoData: null,
    ListVideoData: [],
    LiveVideoData: null,
    videOnPage: 10,
    userEntrance: false,
    adminEntrance: false,
    userId: null
  },

  mutations: {
    // Новые мутации
    SET_USER_STATUS(state, { isLoggedIn, userId = null }) {
      state.user.isLoggedIn = isLoggedIn
      state.user.id = userId
    },

    SET_ADMIN_STATUS(state, isAdmin) {
      state.user.isAdmin = isAdmin
    },

    SET_YOUTUBE_DATA(state, { type, data }) {
      state.youtubeData[type] = data
    },

    INCREASE_VIDEOS_PER_PAGE(state, count) {
      state.videosPerPage += count
    },

    UPDATE_RATE_LIMIT(state, { count, isLimited }) {
      state.rateLimit.count = count
      state.rateLimit.isLimited = isLimited
    },

    // Старые мутации для обратной совместимости
    SET_USER_ENTRANCE(state, userEntrance) {
      state.user.isLoggedIn = userEntrance
    },

    SET_USER_ID(state, userID) {
      state.user.id = userID
    },

    SET_VIDEO(state, LastVideoData) {
      state.youtubeData.lastVideo = LastVideoData
    },

    SET_ONLINE_VIDEO(state, LiveVideoData) {
      state.youtubeData.liveVideo = LiveVideoData
    },

    SET_VIDEO_LIST(state, ListVideoData) {
      state.youtubeData.videoList = ListVideoData
    },

    SET_ADMIN_ENTRANCE(state, adminEntrance) {
      state.user.isAdmin = adminEntrance
    },

    ADD_VIDEO_ON_PAGE(state, count) {
      state.videosPerPage += count
    },

    RESET_REQUEST_COUNT(state) {
      state.rateLimit.count = 0
    }
  },

  actions: {
    // Проверка ограничения запросов
    async rateLimitCheck({ state, commit }) {
      if (state.rateLimit.isLimited) {
        throw new Error('Превышен лимит запросов. Подождите минуту.')
      }

      const newCount = state.rateLimit.count + 1

      if (newCount >= RATE_LIMIT.REQUESTS_PER_MINUTE) {
        commit('UPDATE_RATE_LIMIT', { count: newCount, isLimited: true })

        setTimeout(() => {
          commit('UPDATE_RATE_LIMIT', { count: 0, isLimited: false })
        }, RATE_LIMIT.RESET_TIME)
      } else {
        commit('UPDATE_RATE_LIMIT', { count: newCount, isLimited: false })
      }
    },

    // Универсальный метод для выполнения API запросов
    async fetchFromYoutubeAPI({ dispatch }, { endpoint, dataType }) {
      try {
        await dispatch('rateLimitCheck')

        const response = await fetch(endpoint)
        if (!response.ok) {
          throw new Error(`Ошибка HTTP: ${response.status}`)
        }

        const data = await response.json()
        let result = null

        // Обработка разных типов данных
        if (dataType === 'single') {
          result = data.items && data.items.length > 0 ? data.items[0] : null
        } else {
          result = data.items || []
        }

        return result
      } catch (error) {
        console.error(`Ошибка при выполнении запроса ${endpoint}:`, error)
        throw error
      }
    },

    // === ОРИГИНАЛЬНЫЕ МЕТОДЫ ДЛЯ ОБРАТНОЙ СОВМЕСТИМОСТИ ===

    // Получение последнего видео (старый метод)
    async getLastVideoData({ dispatch, commit }) {
      const endpoint = YOUTUBE_API.ENDPOINTS.playlist(
        YOUTUBE_API.CHANNEL_ID,
        1,
        YOUTUBE_API.KEY
      )

      const data = await dispatch('fetchFromYoutubeAPI', {
        endpoint,
        dataType: 'single'
      })

      commit('SET_VIDEO', data)
    },

    // Получение прямого эфира (старый метод)
    async getLiveVideoData({ dispatch, commit }) {
      const endpoint = YOUTUBE_API.ENDPOINTS.live(
        YOUTUBE_API.CHANNEL_ID,
        YOUTUBE_API.KEY
      )

      const data = await dispatch('fetchFromYoutubeAPI', {
        endpoint,
        dataType: 'single'
      })

      commit('SET_ONLINE_VIDEO', data)
    },

    // Получение списка видео (старый метод)
    async getListVideoData({ dispatch, commit, getters }, payload) {
      const playlistId = (payload && payload.value) ? payload.value : YOUTUBE_API.UPLOADS_PLAYLIST_ID

      const endpoint = YOUTUBE_API.ENDPOINTS.playlist(
        playlistId,
        getters.GET_VIDEO_ON_PAGE,
        YOUTUBE_API.KEY
      )

      const data = await dispatch('fetchFromYoutubeAPI', {
        endpoint,
        dataType: 'list'
      })

      commit('SET_VIDEO_LIST', data)
    },

    // Получение последнего видео (новый метод)
    async fetchLastVideo({ dispatch, commit }) {
      const endpoint = YOUTUBE_API.ENDPOINTS.playlist(
        YOUTUBE_API.CHANNEL_ID,
        1,
        YOUTUBE_API.KEY
      )

      const data = await dispatch('fetchFromYoutubeAPI', {
        endpoint,
        dataType: 'single'
      })

      commit('SET_YOUTUBE_DATA', { type: 'lastVideo', data })
    },

    // Получение прямого эфира (новый метод)
    async fetchLiveVideo({ dispatch, commit }) {
      const endpoint = YOUTUBE_API.ENDPOINTS.live(
        YOUTUBE_API.CHANNEL_ID,
        YOUTUBE_API.KEY
      )

      const data = await dispatch('fetchFromYoutubeAPI', {
        endpoint,
        dataType: 'single'
      })

      commit('SET_YOUTUBE_DATA', { type: 'liveVideo', data })
    },

    // Получение списка видео (новый метод)
    async fetchVideoList({ dispatch, commit, getters }, { playlistId = null } = {}) {
      const endpoint = YOUTUBE_API.ENDPOINTS.playlist(
        playlistId || YOUTUBE_API.UPLOADS_PLAYLIST_ID,
        getters.videosPerPage,
        YOUTUBE_API.KEY
      )

      const data = await dispatch('fetchFromYoutubeAPI', {
        endpoint,
        dataType: 'list'
      })

      commit('SET_YOUTUBE_DATA', { type: 'videoList', data })
    },

    // Увеличение количества видео на странице
    increaseVideosPerPage({ commit }, count = 10) {
      commit('INCREASE_VIDEOS_PER_PAGE', count)
    },

    // Старый метод для совместимости
    addVideosOnPage({ commit }, count) {
      commit('ADD_VIDEO_ON_PAGE', count)
    },

    // Установка статуса пользователя
    setUserStatus({ commit }, { isLoggedIn, userId = null }) {
      commit('SET_USER_STATUS', { isLoggedIn, userId })
    },

    // Установка статуса администратора
    setAdminStatus({ commit }, isAdmin) {
      commit('SET_ADMIN_STATUS', isAdmin)
    }
  },

  getters: {
    // Новые геттеры
    videosPerPage: state => state.videosPerPage,
    userId: state => state.user.id,
    isUserLoggedIn: state => state.user.isLoggedIn,
    isAdmin: state => state.user.isAdmin,
    lastVideo: state => state.youtubeData.lastVideo,
    liveVideo: state => state.youtubeData.liveVideo,
    videoList: state => state.youtubeData.videoList,

    // Старые геттеры для обратной совместимости
    GET_VIDEO_ON_PAGE: state => state.videosPerPage,
    USER_ID: state => state.user.id,
    USER_ENTRANCE: state => state.user.isLoggedIn
  }
})
